import { ACTION_GET_CURRENT_USER_PENDING, ACTION_GET_CURRENT_USER_SUCCESS, ACTION_GET_CURRENT_USER_ERROR } from 'actions/admin-user/action.user-get-current';
import { CHANGE_USER_PASSWORD_PENDING, CHANGE_USER_PASSWORD_SUCCESS, CHANGE_USER_PASSWORD_ERROR } from 'actions/admin-user/action.change-user-password';
import { ACTION_LOG_IN_USER_PENDING, ACTION_LOG_IN_USER_SUCCESS, ACTION_LOG_IN_USER_ERROR } from 'actions/admin-user/action.user-log-in';
import { ACTION_LOG_OUT_USER_PENDING, ACTION_LOG_OUT_USER_SUCCESS, ACTION_LOG_OUT_USER_ERROR } from 'actions/admin-user/action.user-log-out';

const initialState = {
    currentUserPending: false,
    currentUser: null,
    currentUserReady: false,
    currentUserError: null,
    changeUserPasswordPending: false,
    changeUserPasswordSuccess: false,
    changeUserPasswordError: null,
    logInUserPending: false,
    logInUserError: null,
    logOutUserPending: false,
    logOutUserError: null
}

export default function currentUserReducer(state = initialState, action) {
    switch (action.type) {
        case ACTION_GET_CURRENT_USER_PENDING:
            return {
                ...state,
                currentUserPending: true
            }
        case ACTION_GET_CURRENT_USER_SUCCESS:
            return {
                ...state,
                currentUserPending: false,
                currentUserReady: true,
                currentUser: action.currentUser
            }
        case ACTION_GET_CURRENT_USER_ERROR:
            return {
                ...state,
                currentUserPending: false,
                currentUserReady: true,
                currentUserError: action.currentUserError
            }
        case CHANGE_USER_PASSWORD_PENDING:
            return {
                ...state,
                changeUserPasswordPending: true,
                changeUserPasswordSuccess: false,
            }
        case CHANGE_USER_PASSWORD_SUCCESS:
            return {
                ...state,
                changeUserPasswordPending: false,
                changeUserPasswordSuccess: true,
                currentUser: action.currentUser
            }
        case CHANGE_USER_PASSWORD_ERROR:
            return {
                ...state,
                changeUserPasswordPending: false,
                changeUserPasswordError: action.currentUserError
            }
        case ACTION_LOG_IN_USER_PENDING:
            return {
                ...state,
                logInUserPending: true
            }
        case ACTION_LOG_IN_USER_SUCCESS:
            return {
                ...state,
                logInUserPending: false,
                currentUser: action.currentUser
            }
        case ACTION_LOG_IN_USER_ERROR:
            return {
                ...state,
                logInUserPending: false,
                logInUserError: action.error
            }
        case ACTION_LOG_OUT_USER_PENDING:
            return {
                ...state,
                logOutUserPending: true
            }
        case ACTION_LOG_OUT_USER_SUCCESS:
            return {
                ...state,
                logOutUserPending: false,
                currentUser: null
            }
        case ACTION_LOG_OUT_USER_ERROR:
            return {
                ...state,
                logOutUserPending: false,
                logOutUserError: action.error
            }
        default:
            return state;
    }
}

export const getCurrentUserPending = state => state.currentUserReducer.currentUserPending;
export const getCurrentUser = state => state.currentUserReducer.currentUser;
export const getCurrentUserReady = state => state.currentUserReducer.currentUserReady;
export const getCurrentUserError = state => state.currentUserReducer.currentUserError;

export const getChangeUserPasswordPending = state => state.currentUserReducer.changeUserPasswordPending;
export const getChangeUserPasswordSuccess = state => state.currentUserReducer.changeUserPasswordSuccess;
export const getChangeUserPasswordError = state => state.currentUserReducer.changeUserPasswordError;

export const getLogInUserPending = state => state.currentUserReducer.logInUserPending;
export const getLogInUserError = state => state.currentUserReducer.logInUserError;
export const getLogOutUserPending = state => state.currentUserReducer.logOutUserPending;
export const getLogOutUserError = state => state.currentUserReducer.logOutUserError;
